import parser from './parser';

const name = 'datePicker';


export default {parser, name};
